import {
  FETCH_DETAIL_TRUCK_INIT,
  FETCH_DETAIL_TRUCK_SUCCESS,
  FETCH_DETAIL_TRUCK_FAILURE,
  FETCH_DETAIL_TRUCK_RANKING_INIT,
  FETCH_DETAIL_TRUCK_RANKING_SUCCESS,
  FETCH_DETAIL_TRUCK_RANKING_FAILURE,
  FETCH_DETAIL_TRUCK_QUESTION_INIT,
  FETCH_DETAIL_TRUCK_QUESTION_SUCCESS,
  FETCH_DETAIL_TRUCK_QUESTION_FAILURE,
  FETCH_FILTER_INIT,
  FETCH_FILTER_SUCCESS,
  FETCH_FILTER_FAILURE
} from './types';
import API from './api';

/* Detail general view */
function fetchApiSuccess(data) {
  return {
    type: FETCH_DETAIL_TRUCK_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  console.log(error);
  return {
    type: FETCH_DETAIL_TRUCK_FAILURE,
    payload: error
  };
}

function fetchApiInit() {
  return {
    type: FETCH_DETAIL_TRUCK_INIT
  };
}
/* Detail general view */

/* Detail ranking view */
function fetchApiRankingSuccess(data) {
  return {
    type: FETCH_DETAIL_TRUCK_RANKING_SUCCESS,
    payload: data
  };
}

function fetchApiRankingFailure(error) {
  console.log(error);
  return {
    type: FETCH_DETAIL_TRUCK_RANKING_FAILURE,
    payload: error
  };
}

function fetchApiRankingInit() {
  return {
    type: FETCH_DETAIL_TRUCK_RANKING_INIT
  };
}
/* Detail ranking view */

/* Detail question view */
function fetchApiQuestionSuccess(data) {
  return {
    type: FETCH_DETAIL_TRUCK_QUESTION_SUCCESS,
    payload: data
  };
}

function fetchApiQuestionFailure(error) {
  console.log(error);
  return {
    type: FETCH_DETAIL_TRUCK_QUESTION_FAILURE,
    payload: error
  };
}

function fetchApiQuestionInit() {
  return {
    type: FETCH_DETAIL_TRUCK_QUESTION_INIT
  };
}
/* Detail question view */

/* Filters */
function fetchApiFilterSuccess(data) {
  return {
    type: FETCH_FILTER_SUCCESS,
    payload: data
  };
}

function fetchApiFilterFailure(error) {
  console.log(error);
  return {
    type: FETCH_FILTER_FAILURE,
    payload: error
  };
}

function fetchApiFilterInit() {
  return {
    type: FETCH_FILTER_INIT
  };
}
/* Filters */

export function fetchFilterApi(item) {
  return async dispatch => {
    dispatch(fetchApiFilterInit());
    try {
      let data = await API.data.getFilters(item);
      dispatch(fetchApiFilterSuccess(data));
    } catch (error) {
      dispatch(fetchApiFilterFailure(error));
    }
  };
}

export function fetchDetailQuestionApi(item) {
  return async dispatch => {
    dispatch(fetchApiQuestionInit());
    try {
      let data = await API.data.getQuestionData(item);
      dispatch(fetchApiQuestionSuccess(data));
    } catch (error) {
      dispatch(fetchApiQuestionFailure(error));
    }
  };
}

export function fetchDetailRankingApi(item) {
  return async dispatch => {
    dispatch(fetchApiRankingInit());
    try {
      let data = await API.data.getRankingData(item);
      dispatch(fetchApiRankingSuccess(data));
    } catch (error) {
      dispatch(fetchApiRankingFailure(error));
    }
  };
}

export function fetchDetailTruckApi(item) {
  return async dispatch => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(item);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/detail_truck/index.js